import "./CardCommunityClup.scss";
import user3Icon from "../../image/userThree.svg";
import notebookIcon from "../../image/Notebook.svg";
import { differenceInDays, parse } from "date-fns";

interface Props {
	data: {
		id: number;
		userImage: string | undefined;
		countViews: number;
		countComments: number;
		title: string;
		orderType: string | undefined;
		description: string;
		userNickname: string | undefined;
		nation: string;
		startDate: string;
		endDate: string;
		genderType: string;
		age: string;
		maxMember: number;
		currentMember: number;
		tripType: string;
		images: string[];
	};
	onClick?: () => void;
}

const ViewIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.27145 5.39645C3.46336 4.20453 5.33371 3 8 3C10.6663 3 12.5366 4.20453 13.7286 5.39645C14.3231 5.99096 14.7518 6.58461 15.0325 7.03047C15.1731 7.25379 15.2773 7.44117 15.3472 7.57464C15.3822 7.64141 15.4086 7.69479 15.4268 7.73255C15.4359 7.75144 15.4429 7.76643 15.4479 7.77725L15.4539 7.79032L15.4558 7.79445L15.4564 7.7959L15.4567 7.79646C15.4568 7.79671 15.4569 7.79693 15 8C15.4569 8.20307 15.4568 8.20329 15.4567 8.20354L15.4564 8.2041L15.4558 8.20555L15.4539 8.20968L15.4479 8.22275C15.4429 8.23357 15.4359 8.24856 15.4268 8.26745C15.4086 8.30521 15.3822 8.35859 15.3472 8.42536C15.2773 8.55883 15.1731 8.74621 15.0325 8.96953C14.7518 9.41539 14.3231 10.009 13.7286 10.6036C12.5366 11.7955 10.6663 13 8 13C5.33371 13 3.46336 11.7955 2.27145 10.6036C1.67693 10.009 1.24824 9.41539 0.967509 8.96953C0.826899 8.74621 0.722698 8.55883 0.652787 8.42536C0.617813 8.35859 0.591364 8.30521 0.573181 8.26745C0.564087 8.24856 0.557055 8.23357 0.552053 8.22275L0.546066 8.20968L0.544205 8.20555L0.543556 8.2041L0.543302 8.20354C0.543194 8.20329 0.543094 8.20307 1 8C0.543094 7.79693 0.543194 7.79671 0.543302 7.79646L0.543556 7.7959L0.544205 7.79445L0.546066 7.79032L0.552053 7.77725C0.557055 7.76643 0.564087 7.75144 0.573181 7.73255C0.591364 7.69479 0.617813 7.64141 0.652787 7.57464C0.722698 7.44117 0.826899 7.25379 0.967509 7.03047C1.24824 6.58461 1.67693 5.99096 2.27145 5.39645ZM1 8L0.543094 7.79693C0.485635 7.92621 0.485635 8.07379 0.543094 8.20307L1 8ZM1.55906 8C1.61788 8.11018 1.70235 8.25981 1.81374 8.43672C2.06426 8.83461 2.44807 9.36596 2.97855 9.89645C4.03664 10.9545 5.66629 12 8 12C10.3337 12 11.9634 10.9545 13.0214 9.89645C13.5519 9.36596 13.9357 8.83461 14.1863 8.43672C14.2976 8.25981 14.3821 8.11018 14.4409 8C14.3821 7.88982 14.2976 7.74019 14.1863 7.56328C13.9357 7.16539 13.5519 6.63404 13.0214 6.10355C11.9634 5.04547 10.3337 4 8 4C5.66629 4 4.03664 5.04547 2.97855 6.10355C2.44807 6.63404 2.06426 7.16539 1.81374 7.56328C1.70235 7.74019 1.61788 7.88982 1.55906 8ZM15 8L15.4569 8.20307C15.5144 8.07379 15.5144 7.92621 15.4569 7.79693L15 8Z"
				fill="#0E1111"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6ZM5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8Z"
				fill="#0E1111"
			/>
		</svg>
	);
};

const CommentIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.25 2.5C6.85761 2.5 5.52225 3.05312 4.53769 4.03769C3.55312 5.02226 3 6.35761 3 7.75V13H8.25C8.93944 13 9.62212 12.8642 10.2591 12.6004C10.896 12.3365 11.4748 11.9498 11.9623 11.4623C12.4498 10.9748 12.8365 10.396 13.1004 9.75909C13.3642 9.12213 13.5 8.43944 13.5 7.75C13.5 7.06056 13.3642 6.37787 13.1004 5.74091C12.8365 5.10395 12.4498 4.5252 11.9623 4.03769C11.4748 3.55018 10.896 3.16347 10.2591 2.89963C9.62212 2.6358 8.93944 2.5 8.25 2.5ZM8.25 14H2.98397C2.85509 14.0012 2.72723 13.9768 2.60781 13.9283C2.48718 13.8792 2.3776 13.8065 2.28553 13.7145C2.19345 13.6224 2.12075 13.5128 2.07172 13.3922C2.02318 13.2728 1.9988 13.1449 2 13.016V7.75C2 6.0924 2.65848 4.50268 3.83058 3.33058C5.00268 2.15848 6.59239 1.5 8.25 1.5C9.07076 1.5 9.88348 1.66166 10.6418 1.97575C11.4001 2.28984 12.089 2.75022 12.6694 3.33058C13.2498 3.91095 13.7102 4.59994 14.0242 5.35823C14.3383 6.11651 14.5 6.92924 14.5 7.75C14.5 8.57076 14.3383 9.38349 14.0242 10.1418C13.7102 10.9001 13.2498 11.5891 12.6694 12.1694C12.089 12.7498 11.4001 13.2102 10.6418 13.5242C9.88348 13.8383 9.07076 14 8.25 14Z"
				fill="#0E1111"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.75 7C5.75 6.72386 5.97386 6.5 6.25 6.5H10C10.2761 6.5 10.5 6.72386 10.5 7C10.5 7.27614 10.2761 7.5 10 7.5H6.25C5.97386 7.5 5.75 7.27614 5.75 7Z"
				fill="#0E1111"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.75 9C5.75 8.72386 5.97386 8.5 6.25 8.5H10C10.2761 8.5 10.5 8.72386 10.5 9C10.5 9.27614 10.2761 9.5 10 9.5H6.25C5.97386 9.5 5.75 9.27614 5.75 9Z"
				fill="#0E1111"
			/>
		</svg>
	);
};

const ThreeIcon = () => {
	return (
		<svg width="13" height="13" viewBox="0 0 13 13" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.5 5.48438C5.60254 5.48438 4.875 6.21191 4.875 7.10938C4.875 8.00684 5.60254 8.73438 6.5 8.73438C7.39746 8.73438 8.125 8.00684 8.125 7.10938C8.125 6.21191 7.39746 5.48438 6.5 5.48438ZM4.0625 7.10938C4.0625 5.76318 5.15381 4.67188 6.5 4.67188C7.84619 4.67188 8.9375 5.76318 8.9375 7.10938C8.9375 8.45557 7.84619 9.54688 6.5 9.54688C5.15381 9.54688 4.0625 8.45557 4.0625 7.10938Z"
				fill="#F5F5F5"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.1346 6.57458C10.768 6.39129 10.3637 6.29619 9.9538 6.29688C9.72944 6.29725 9.54725 6.11567 9.54688 5.89131C9.5465 5.66694 9.72808 5.48476 9.95245 5.48438C10.4889 5.48348 11.0181 5.60795 11.4979 5.84786C11.9778 6.08777 12.3949 6.43648 12.716 6.86617C12.8504 7.04589 12.8135 7.30047 12.6338 7.43479C12.4541 7.56911 12.1995 7.5323 12.0652 7.35259C11.8199 7.02429 11.5012 6.75787 11.1346 6.57458Z"
				fill="#F5F5F5"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.04619 6.29688C2.63634 6.29619 2.23199 6.39129 1.86541 6.57458C1.49882 6.75787 1.18014 7.02429 0.934776 7.35259C0.800457 7.5323 0.54588 7.56911 0.366163 7.43479C0.186445 7.30047 0.149643 7.04589 0.283962 6.86617C0.605113 6.43648 1.02223 6.08777 1.50205 5.84786C1.98186 5.60795 2.5111 5.48348 3.04755 5.48438C3.27191 5.48476 3.45349 5.66694 3.45312 5.89131C3.45274 6.11567 3.27055 6.29725 3.04619 6.29688Z"
				fill="#F5F5F5"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.50001 9.54822C5.9664 9.54822 5.44351 9.69809 4.99091 9.98076C4.53831 10.2634 4.17421 10.6675 3.94007 11.147C3.84162 11.3487 3.59837 11.4323 3.39676 11.3338C3.19515 11.2354 3.11151 10.9922 3.20996 10.7905C3.51087 10.1743 3.97883 9.65492 4.56051 9.29163C5.14218 8.92833 5.81421 8.73572 6.50001 8.73572C7.18582 8.73572 7.85784 8.92833 8.43952 9.29163C9.0212 9.65492 9.48915 10.1743 9.79007 10.7905C9.88851 10.9922 9.80488 11.2354 9.60327 11.3338C9.40165 11.4323 9.1584 11.3487 9.05996 11.147C8.82582 10.6675 8.46171 10.2634 8.00912 9.98076C7.55652 9.69809 7.03363 9.54822 6.50001 9.54822Z"
				fill="#F5F5F5"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.34791 3.08506C3.12384 3.02761 2.88805 3.03512 2.66808 3.1067C2.44812 3.17828 2.25307 3.31098 2.10572 3.4893C1.95838 3.66762 1.86482 3.88418 1.83598 4.1137C1.80715 4.34321 1.84423 4.57619 1.94288 4.78542C2.04154 4.99464 2.1977 5.17147 2.39312 5.29524C2.58854 5.41901 2.81515 5.48461 3.04646 5.48437C3.27083 5.48415 3.4529 5.66585 3.45313 5.89021C3.45335 6.11458 3.27165 6.29665 3.04729 6.29687C2.66176 6.29727 2.28408 6.18793 1.95838 5.98165C1.63268 5.77536 1.37241 5.48065 1.20798 5.13194C1.04356 4.78324 0.981763 4.39493 1.02982 4.01241C1.07788 3.62989 1.23381 3.26894 1.47939 2.97175C1.72497 2.67455 2.05005 2.45338 2.41666 2.33408C2.78326 2.21478 3.17625 2.20227 3.5497 2.29802C3.92315 2.39377 4.26164 2.59382 4.52562 2.87479C4.7896 3.15577 4.96817 3.50607 5.04045 3.88476C5.08252 4.10515 4.93797 4.31791 4.71758 4.35998C4.49719 4.40205 4.28443 4.2575 4.24236 4.03711C4.19899 3.80989 4.09185 3.59971 3.93346 3.43113C3.77508 3.26254 3.57198 3.14251 3.34791 3.08506Z"
				fill="#F5F5F5"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.3319 3.1067C10.112 3.03512 9.87616 3.02761 9.65209 3.08506C9.42802 3.14251 9.22493 3.26254 9.06654 3.43113C8.90815 3.59971 8.80101 3.80989 8.75764 4.03711C8.71557 4.2575 8.50281 4.40205 8.28242 4.35998C8.06204 4.31791 7.91748 4.10515 7.95955 3.88476C8.03184 3.50607 8.2104 3.15577 8.47438 2.87479C8.73836 2.59382 9.07685 2.39377 9.4503 2.29802C9.82375 2.20227 10.2167 2.21478 10.5833 2.33408C10.95 2.45338 11.275 2.67455 11.5206 2.97175C11.7662 3.26894 11.9221 3.62989 11.9702 4.01241C12.0182 4.39493 11.9564 4.78324 11.792 5.13194C11.6276 5.48065 11.3673 5.77536 11.0416 5.98165C10.7159 6.18793 10.3382 6.29727 9.95271 6.29687C9.72835 6.29665 9.54665 6.11458 9.54688 5.89021C9.5471 5.66585 9.72917 5.48415 9.95354 5.48437C10.1849 5.48461 10.4115 5.41901 10.6069 5.29524C10.8023 5.17147 10.9585 4.99464 11.0571 4.78542C11.1558 4.57619 11.1929 4.34321 11.164 4.1137C11.1352 3.88418 11.0416 3.66762 10.8943 3.4893C10.7469 3.31098 10.5519 3.17828 10.3319 3.1067Z"
				fill="#F5F5F5"
			/>
		</svg>
	);
};

const NotebookIcon = () => {
	return (
		<svg width="13" height="13" viewBox="0 0 13 13" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.28125 5.6875C5.28125 5.46313 5.46313 5.28125 5.6875 5.28125H8.9375C9.16187 5.28125 9.34375 5.46313 9.34375 5.6875C9.34375 5.91187 9.16187 6.09375 8.9375 6.09375H5.6875C5.46313 6.09375 5.28125 5.91187 5.28125 5.6875Z"
				fill="#F5F5F5"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.28125 7.3125C5.28125 7.08813 5.46313 6.90625 5.6875 6.90625H8.9375C9.16187 6.90625 9.34375 7.08813 9.34375 7.3125C9.34375 7.53687 9.16187 7.71875 8.9375 7.71875H5.6875C5.46313 7.71875 5.28125 7.53687 5.28125 7.3125Z"
				fill="#F5F5F5"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.625 2.4375C1.625 1.98877 1.98877 1.625 2.4375 1.625H10.5625C11.0112 1.625 11.375 1.98877 11.375 2.4375V10.5625C11.375 11.0112 11.0112 11.375 10.5625 11.375H2.4375C1.98877 11.375 1.625 11.0112 1.625 10.5625V2.4375ZM10.5625 2.4375H2.4375V10.5625H10.5625V2.4375Z"
				fill="#F5F5F5"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.0625 1.625C4.28687 1.625 4.46875 1.80688 4.46875 2.03125V10.9688C4.46875 11.1931 4.28687 11.375 4.0625 11.375C3.83813 11.375 3.65625 11.1931 3.65625 10.9688V2.03125C3.65625 1.80688 3.83813 1.625 4.0625 1.625Z"
				fill="#F5F5F5"
			/>
		</svg>
	);
};

function MainCardCommunityClup({ data, onClick = () => {} }: Props) {
	const transformNightsAndDays = (startedAt: string, endedAt: string) => {
		const day = Math.round((new Date(endedAt).getTime() - new Date(startedAt).getTime()) / (1000 * 60 * 60 * 24));

		return `${day}박 ${day + 1}일`;
	};

	function dateFormat(date: Date) {
		let month: any = date.getMonth() + 1;
		let day: any = date.getDate();

		return `${date.getFullYear()}-${("0" + month).slice(-2)}-${("0" + day).slice(-2)}`;
	}

	return (
		<div className="card-community-clup" onClick={onClick}>
			<div className="flex items-center px-[5px] h-[32px] xl:h-[59px] gap-[5px] xl:gap-[12px]">
				<div className="w-[21px] aspect-square bg-gray-200 rounded-full overflow-hidden ">
					{data.userImage && <img src={data.userImage} alt="user_profile" />}
				</div>
				<div className="flex flex-1 justify-between items-center">
					<div className="text-[10px] flex-1 font-medium xl:text-[14px] truncate">{data.userNickname}</div>
					<div className="">
						{data.orderType === "RECRUITMENT" ? (
							<div className="flex bg-[#F67280] text-white text-[10px] font-medium px-[5px] py-[4px] gap-[5px] rounded-[2px] items-center xl:text-[12px] ">
								<ThreeIcon />
								모집
							</div>
						) : (
							<div className="flex bg-[#A870B1] text-white text-[10px] font-medium px-[5px] py-[4px] gap-[5px] rounded-[2px] items-center  xl:text-[12px]">
								<NotebookIcon />
								계획
							</div>
						)}
					</div>
				</div>
			</div>

			<div className="card-community-clup__image " style={{ backgroundImage: `url(${data.images[0]})` }}>
				<div className="text-[10px] flex max-w-[90%] flex-wrap  mr-auto p-auto absolute top-[5px] left-[5px]  text-white font-medium bg-[#355C7D] px-[9px] py-[4px] xl:text-[12px] line-clamp-1">
					<div className="truncate xl:max-w-none">{data.nation}</div>
					<div>/{transformNightsAndDays(data.startDate, data.endDate)}</div>
				</div>
			</div>
			<div className="text-[14px] font-bold mb-[10px] line-clamp-2 px-[5px] mt-[10px] xl:text-[20px]">{data.title}</div>
			<div className="text-[12px] font-normal px-[5px] xl:text-[18px]  text-[#424549] xl:mt-[16px]">
				{data.maxMember}명{`${data.genderType ? "·" + data.genderType : ""}`}
				{`${data.age ? "·" + data.age : ""}`}
			</div>
			<div className="text-[12px] font-normal px-[5px] mt-[10px]  text-[#424549] xl:text-[18px] xl:mt-[8px]">
				{dateFormat(new Date(data.startDate))} ~ {dateFormat(new Date(data.endDate))}
			</div>
			<div className="text-[12px] font-bold mt-[10px] px-[5px] text-[#0057FF] xl:text-[18px] xl:mt-[8px]">
				{data?.currentMember === data.maxMember ? (
					"모집완료"
				) : (
					<span>
						{data?.currentMember}명 / {data.maxMember}명 모집중
					</span>
				)}
			</div>

			<div className="flex justify-end gap-[15px] text-[10px] font-medium items-center mb-[10px] mt-[22px] px-[6px] xl:text-[18px] xl:mt-[16px]">
				<div className="flex gap-[5px] items-center cursor-pointer">
					<ViewIcon />
					{data.countViews}
				</div>
				<div className="flex gap-[5px] items-center cursor-pointer">
					<CommentIcon />
					{data.countComments}
				</div>
			</div>
		</div>
	);
}

export default MainCardCommunityClup;
